import { CURRENCY } from '@/const/currency'

export const BILLING_CURRENCY = CURRENCY.CHF
